export const roundFloat = (number: number, fractionDigits: number): number => {
  return Number.parseFloat(number.toFixed(fractionDigits))
}
